export const getUi = state => state.ui;
export const getShowSettings = state => getUi(state).showSettings;
export const getShowLevels = state => getUi(state).showLevels;
export const getShowLogin = state => getUi(state).showLogin;
export const getShowPaywall = state => getUi(state).showPaywall;
export const getShowSecret = state => getUi(state).showSecret;
export const getShowSolved = state => getUi(state).showSolved;
export const getShowLanguages = state => getUi(state).showLanguages;
export const getShowPlayers = state => getUi(state).showPlayers;
export const getShowPrizes = state => getUi(state).showPrizes;
export const getShowAbout = state => getUi(state).showAbout;



// WEBPACK FOOTER //
// ./src/reducers/ui/selectors.js